import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Footer as BrFooter } from '@vwfs-bronson/bronson-react';
import { Page } from '../..';
import { customSelectors } from '../../services/redux/features/custom.slice';

export type FooterProps = {
  pages: { hybridJourney: Page[]; dealerJourney: Page[] };
};

export const FooterAction = {
  SHOW_COOKIE_TAB: 'show-cookie-tab',
} as const;

export type FooterActionType = (typeof FooterAction)[keyof typeof FooterAction];

export const Footer: FunctionComponent<FooterProps> = ({ pages }) => {
  const { t } = useTranslation();
  const isHybridJourney = useSelector(customSelectors.selectIsHybridJourney);
  const pagesToRender = isHybridJourney ? pages.hybridJourney : pages.dealerJourney;

  const handleShowCookieTab = (action?: FooterActionType) => {
    if (action !== FooterAction.SHOW_COOKIE_TAB) return;

    if (window['CookieControl'] && window['CookieControl'].open) {
      window['CookieControl'].open();
    } else {
      // CookieControl is not loaded yet: load the script and open the panel once it's ready
      const script = document.createElement('script');
      script.src = 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.10.1.min.js';
      script.async = true;
      script.onload = () => {
        window['CookieControl'].open();
      };
      document.body.appendChild(script);
    }
  };

  return (
    <>
      <BrFooter>
        <BrFooter.ModuleMetaNav
          metaSectionLabel={t('app:footer:companyInfo')}
          copyrightText={`${t('app:footer:copyright')} ${new Date().getFullYear()}`}
        >
          {pagesToRender.length &&
            pagesToRender.map((currentPage) => (
              <BrFooter.ModuleMetaNav.Item
                key={currentPage.name ? currentPage.name : undefined}
                href={currentPage.url ? currentPage.url : undefined}
                linkProps={{
                  target: currentPage.target,
                  normalLink: true,
                  onClick: () => handleShowCookieTab(currentPage.action as FooterActionType),
                }}
              >
                {currentPage.name}
              </BrFooter.ModuleMetaNav.Item>
            ))}
        </BrFooter.ModuleMetaNav>
      </BrFooter>
    </>
  );
};
